import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLoafers = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M21.3849 8.93656L21.9019 7.90273C22.0563 7.59438 21.9311 7.21983 21.6224 7.06545C21.3145 6.9123 20.9399 7.03702 20.7855 7.34454L20.2843 8.34701L11.9439 10.73L11.3095 9.24984C11.1836 8.95611 10.8565 8.80581 10.5522 8.89924L4.22988 10.8447C2.89618 11.2546 2 12.4677 2 13.8635C2 15.2399 3.11961 16.3595 4.49596 16.3595H21.3437C21.6882 16.3595 21.9677 16.08 21.9677 15.7355V13.8635C21.9677 13.8628 21.9673 13.8622 21.9673 13.8614C22.085 12.1875 21.8837 10.5341 21.3849 8.93656ZM20.3037 9.63942C20.6335 10.8134 20.772 12.0202 20.7392 13.2396H13.0195L12.4394 11.886L20.3037 9.63942ZM4.59671 12.0379L10.3832 10.2569L11.6613 13.2396H3.35264C3.54637 12.6739 3.99796 12.2218 4.59671 12.0379ZM20.7197 15.1115H4.49596C4.03487 15.1115 3.63148 14.8605 3.41535 14.4875H20.7197V15.1115Z",
		fill: "currentColor"
	})
});
export default SvgLoafers;
